package views.coletor

import androidx.compose.runtime.*
import div1Hei
import ffButton0
import ffButtonDiv
import ffEspHorizontalP
import ffEspVerticalMil
import ffMsgWindow
import ffRadioInput
import ffSpan
import kotlinx.browser.document
import kotlinx.dom.clear
import lbTitulo
import model.Produto
import model.Produtolote
import ffMsgAviso
import org.jetbrains.compose.web.css.*
import org.jetbrains.compose.web.dom.*
import org.jetbrains.compose.web.renderComposable
import org.w3c.dom.HTMLDivElement
import utils.*
import utils.ff.Companion.giEmpresa
import utils.ff.Companion.goEMPRESA
import utils.ff.Companion.gsParam1
import utils.ff.Companion.println0
import views.componentes.*
import kotlin.js.Date

class col001 {

    private val _t = "col001" //consulta produto
    private var lpro: List<Produto>? = null
    private var lproLote: List<Produtolote>? = null
    val tab1 = table1()


    fun show(_produto: String) {

        lbTitulo!!.innerText = "001 - Consulta produto"

        val htmlDiv1 = document.getElementById("htmlDiv1") as HTMLDivElement
        htmlDiv1.clear()

        renderComposable(rootElementId = "htmlDiv1") {
            body1(_produto)

        }
    }

    @Composable
    private fun body1(_produto: String) {

        println0("body1 inicio ${_produto}")
        val _body1 = remember { mutableStateOf("codigo") }

        Div(attrs = { classes("form-group", "dlg-pad-top-5") }) {

            ffSpan("Descrição, código ou EAN")

            val _codigo = remember { mutableStateOf(gsInput(_tela = _t, _id = "_codigo", _text = _produto)) }
            val sBtText = remember { mutableStateOf("") }
            sBtText.value = if (goEMPRESA.EMP_COLDIGPROD.equals("NS")) ":01" else ":ab"

            Div({ classes("input-group-append") }) {

                ffInput44(":Descrição, código ou EAN", _codigo, goEMPRESA.EMP_COLDIGPROD, 0, 100, false,
                    _onFocusIn = {},
                    _onFocusOut = {})
                _codigo.onKeyPressENTER {
                    if (!_codigo.text().equals("")) {
                        //ffMsgWindow("entrou no onKeyPressENTER")
                        ffAudio().ffPlayBeep(true)

                        println0("zuza8787 vai entrar no onKeyPressEnter ${_codigo.key()} $gsKey")
                        _codigo.enabled(false)
                        Produto().consultarProduto(_codigo.text_getPROBLEMA(), false) { lista ->
                            lpro = lista
                            ff().ffSetFocus("btCabecVoltar")
                            _body1.dAtualize("barras")
                        }
                    }
                }


                ffButton0(sBtText.value, {
                    goEMPRESA.EMP_COLDIGPROD = if (goEMPRESA.EMP_COLDIGPROD.equals("NS")) "S" else "NS"
                    sBtText.value = if (goEMPRESA.EMP_COLDIGPROD.equals("NS")) ":01" else ":ab"
                    goEMPRESA.atualizaEmpresa()
                }, 40)
            }


            //if (_tela.value.equals("_codigo")) {
            if (_codigo.enabled()) {
                SideEffect { _codigo.setFocusSimples(true) }
            }

            if (_body1.value.equals("barras")) {
                body2(_codigo)
            }
        }

    }

    @Composable
    private fun body2(_codigo: MutableState<String>) {

        //println0("body2 inicio")
        val _body2 = remember { mutableStateOf("") }
        //println0("body2 inicio1")

        //println0("zuza aqui 123")
        // && !_tela.value.equals("barras.lote")) {
        //if (_tela.value.equals("barras")) {
        //_tela.value = "barras1"
        val _aUnid = Array<String>(size = 3, init = { index -> "" })
        _aUnid[0] = "Unidade"
        _aUnid[1] = "Display"
        _aUnid[2] = "Cx. Embarque"

        val _selecionado = remember { mutableStateOf("") }
        val _rdEan = remember { mutableStateOf(-1) }
        val _pro = lpro!![0]
        var sUnid = "Unidade|Display|Caixa|"

        //println0(lobj!!)
        /*
        when (_pro.EST_BARRAOFICIAL) {
            "U" -> _rdEan.value = 0
            "D" -> _rdEan.value = 1
            "C" -> _rdEan.value = 2
        }
        */

        //div para descritivo do produto
        val _txLocal = remember { mutableStateOf("") }
        val _txSaldo = remember { mutableStateOf("") }
        _txLocal.value = "Local: ${_pro.EST_LOCAL00}"
        _txSaldo.value = "Saldo: ${_pro.EST_SALDO}"

        println0("_codigo=${_codigo.text()} rdEan=${_rdEan.value}")

        Div({ classes("form-group", "dlg-div-detalhes"); style { display(DisplayStyle.Block) } }) {
            ffSpan("Descr.: ${lpro!![0].ID_PRODUTO} - ${lpro!![0].OO_DESCRCOMPLETA}")
            //if (!lpro!![0].PRO_REFER.equals(""))
            //ffSpan("Referência: ${lpro!![0].PRO_REFER}")

            if (lpro!![0].PROLOT_ID != 0)
                ffSpan("Lote: ${lpro!![0].PROLOT_ID} - Fabricante:${lpro!![0].PROLOT_LOTEFAB}")
            if (!lpro!![0].PROLOT_OBS.equals(""))
                ffSpan("Obs Lote: ${lpro!![0].PROLOT_OBS}")
            Hr({ classes("dlg-hr") })
            ffEspVerticalMil(2)
            println0(lpro)

            Div() {
                var obj = Produto().reg(_pro.ID_PRODUTO, "U", lpro!!)
                println0(obj)

                println0(
                    "aquiRadio99U ${obj.ESTG_EAN} ${obj.ID_PRODUTO} ${_rdEan.value}" +
                            " ESTG_UNIDVENDA = ${_pro.ESTG_UNIDVENDA} ESTG_TIPO = ${_pro.ESTG_TIPO}"
                )
                if (_pro.ESTG_TIPO.equals("U")) {
                    _rdEan.value = 0
                }
                if (!obj.ESTG_EAN.equals("")) {
                    ffRadioInput(
                        "Unidade " + obj.ESTG_EAN, _rdEan, 0, 0
                    )
                    sUnid = sUnid.replace("Unidade|", "")
                }


                obj = Produto().reg(_pro.ID_PRODUTO, "D", lpro!!)
                println0(
                    "aquiRadio99D ${obj.ESTG_EAN} ${obj.ID_PRODUTO} ${_rdEan.value}" +
                            " ESTG_UNIDVENDA = ${_pro.ESTG_UNIDVENDA} ESTG_TIPO = ${_pro.ESTG_TIPO}"
                )
                val teste = _codigo.text().equals(_pro.ESTG_EAN)
                if (_pro.ESTG_TIPO.equals("D")) {
                    _rdEan.value = 1
                }

                if (!obj.ESTG_EAN.equals("")) {
                    ffRadioInput(
                        "Display " + obj.ESTG_EAN + " Qtde: ${obj.ESTG_UNIDVENDA}", _rdEan, 1, 0
                    )
                    sUnid = sUnid.replace("Display|", "")
                }


                obj = Produto().reg(_pro.ID_PRODUTO, "C", lpro!!)
                println0(
                    "aquiRadio99C ${obj.ESTG_EAN} ${obj.ID_PRODUTO} ${_rdEan.value}" +
                            " ESTG_UNIDVENDA = ${_pro.ESTG_UNIDVENDA} ESTG_TIPO = ${_pro.ESTG_TIPO}"
                )
                if (_pro.ESTG_TIPO.equals("C")) {
                    _rdEan.value = 2
                }
                if (!obj.ESTG_EAN.equals("")) {
                    ffRadioInput(
                        "Caixa " + obj.ESTG_EAN + " Qtde: ${obj.ESTG_UNIDVENDA}", _rdEan, 2, 0
                    )
                    sUnid = sUnid.replace("Caixa|", "")
                }

                ffSpan("Obs: Informe -1 na Qtde para excluir um código de barras")
            }

            Hr({ classes("dlg-hr") })
            ffEspVerticalMil(2)
            Div { //sem essa div ao rescrever o span dá erro some o RadioInput
                ffSpan(_txLocal.value)
                ffSpan(_txSaldo.value)
            }
        }

        if (sUnid.equals(""))
            sUnid = "Caixa"

        if (!sUnid.equals("")) {
            val _seUnidVenda = remember { mutableStateOf("") }
            val _qtde = remember { mutableStateOf(gsInput(_t)) }
            val _ean = remember { mutableStateOf(gsInput(_t)) }
            Div({ classes("form-group", "input-group-append"); style { height(50.px) } }) {
                ffCombo1Simples(
                    "Unid. venda",
                    sUnid.replace("|", ""),
                    _seUnidVenda,
                    30,
                    "",
                    true,
                    {},
                    "_seUnidVenda"
                )
                ffInput1("Qtde:", _qtde, "N", 5, 15, true)
                ffInput1("Cód. EAN /DUN", _ean, "S", 15, 60, false)
            }
            Div({ classes("form-group", "input-group-append") }) {

                ffButton0("Nova consulta", { clickNovaConsulta() }, 50)
                ffEspHorizontalP(5)
                if (!gsParam1.equals("")) {
                    ffButton0("Voltar a OF", { ff().ffLocalizarOf() }, 50)
                    //ffButton("Voltar a OF", { println0("teste") }, 50)
                } else {
                    ffButton0(
                        "Gravar", {
                            clickGravar(
                                _body2, _pro, _seUnidVenda.value.ffCopy(1, 1),
                                _ean.text(), _qtde.text(), _rdEan.value
                            ) { o ->
                                //_codigo.keySet("Enter")
                            }
                        }, 50
                    )
                }
            }
            _body2.value = "carregar3"
        }

        //até aqui
        //body3(sUnid, _txLocal, _txSaldo)
        if (_body2.value.equals("carregar3"))
            body3(sUnid, _txSaldo)
    }

    @Composable
    fun body3(_unid: String, _txSaldo: MutableState<String>) {

        val _pro = lpro!![0]
        val _body3 = remember { mutableStateOf("") }

        ffEspVerticalMil(2)

        Produtolote().getProdutoLoteSaldo(_pro.ID_PRODUTO.toString()) { lo ->
            println0("336 getProdutoLoteSaldo")
            //println0(lo)
            lproLote = lo
            val dSoma = lo.sumOf { p -> p.PROLOT_SALDO }
            val dDif = _pro.EST_SALDO - dSoma

            _txSaldo.value = "Saldo: ${_pro.EST_SALDO}"
            if (dDif.ffDif(0.0))
                _txSaldo.value = "Saldo: ${_pro.EST_SALDO} # Saldo do lote: $dSoma difere em $dDif"
            else
                _txSaldo.value = "Saldo: ${_pro.EST_SALDO}"
            _body3.dAtualize("carrega4")
        }
        //área do grid table
//        if (_body3.value.equals("carrega4")) {
//            body4(_txSaldo)
//        }
//        val _body4 = remember { mutableStateOf("") }

        if (_body3.value.equals("carrega4")) {
            val _tb1Lote = remember { mutableStateOf(gsInput(_t)) } //limpar o value após o uso
            println0("vai imprimir lproLote")
            println0(lproLote)
            if (lproLote != null) {

                val lcon = ArrayList<table1>()
                lcon.add(table1().add(20, "D", "N", "PROLOT_DTVAL  ", "Venc."))
                lcon.add(table1().add(20, "S", "N", "PROLOT_LOTEFAB", "Lote"))
                lcon.add(table1().add(20, "N", "N", "PROLOT_SALDO  ", "Saldo"))
                lcon.add(table1().add(30, "N", "S", "DIF_SALDO00   ", "Qtde"))
                lcon.add(table1().add(10, "B", "N", "OK            ", "Ok"))

                //_table1Controler.json(JSON.stringify(lproLote).ffJsonParse(false))
                val s = JSON.stringify(lproLote).ffJsonParse(false)
                tab1.ffTable1(lcon, _json = s, _table1Controler = _tb1Lote)

                lproLote = Produtolote().construtorLista(tab1.lista01!!) //reconstroi o objeto

                println0("zuza12345 ${_tb1Lote.clickObj()}")

                if (_tb1Lote.clickObj() >= 0 && _tb1Lote.clickTipo().equals("Button")) {
                    println0(lproLote!!.get(_tb1Lote.clickObj()))
                    atualizarProdutoLote(lproLote!!.get(_tb1Lote.clickObj())) { _ok ->
                        //if (_ok) //vai voltar ao topo limpando inclusive o _table1ClickControler
                        _tb1Lote.clickLimpar()
                        lproLote = null
                        _txSaldo.value = ""
                        _body3.dAtualize("")
                    }
                }
            }
        }

        //área do Novo Lote
        bodyNovoLote(_body3)

        //carrega a imagem do produto
        bodyImagem()
    }

//    @Composable
//    fun body4(_txSaldo: MutableState<String>) {
//
//    }

    fun MutableState<String>.dAtualize(_valor: String) { //} atualizaMutable(_tela: MutableState<String>, _valor:String) {
        if (!this.value.equals(_valor))
            this.value = _valor
    }

    @Composable
    fun bodyImagem() {

        println0("vai carregar a imagem de")
        println0(ff.goEMPRESA)
        val sImg = ff.goEMPRESA.EMP_URLPRO00 + lpro!![0].ID_PRODUTO.ffZeroLeft(6)
        println0("zuza=${sImg}")

        Div({
            classes("imagemLarg");
            style {
                display(DisplayStyle.Block)
                //height(600.px)
                width(90.percent)
                backgroundImage("url(${sImg + "_1.jpg?" + Date().ffDdBr(2)})")
            }
        }) {

        }
    }

    /*
    fun ffCarregarImg(_img: String, _ele: HTMLDivElement, cb: (Boolean) -> Unit) {

        var bContinua = false
        _ele.style.display = "block"
        try {
            println0(_img)
            println0("aplicando style.background")

            _ele.style.backgroundImage = "url(${_img + "_0.jpg?" + Date().ffDdBr(2)})"

            println0("aplicado")
            bContinua = true
            cb(bContinua)

        } catch (e: Exception) {
            try {
                println0("falha ao carregar a imagem ${e.message}")
                _ele.style.backgroundImage = "url(${_img + "_1.jpg?" + Date().ffDdBr(2)})"
                bContinua = true
                cb(bContinua)

            } catch (e: Exception) {
                cb(false)
            }
        }
    }

     */


    @Composable
//@NonRestartableComposable
    fun bodyNovoLote(_tela: MutableState<String>) {

        val _txnLote = remember { mutableStateOf(gsInput(_t)) }
        val _txnValid = remember { mutableStateOf(gsInput(_t)) }
        val _txnFabric = remember { mutableStateOf(gsInput(_t)) }
        val _txnSaldo = remember { mutableStateOf(gsInput(_t)) }
        val _txnQtdEmb = remember { mutableStateOf(gsInput(_t)) }
        //val _clickButton = remember { mutableStateOf("") }

        var bClick: Boolean = false
        val opro = lpro!![0]

        ffSpan("Novo lote", true)
        Hr({ classes("dlg-hr") })
        Div({ classes("form-group", "input-group-append"); style { height(div1Hei) } }) {
            if (goEMPRESA.EMP_ENTRFRACIONADA.equals("S"))
                ffInput1("Qtd Embalagem", _txnQtdEmb, "N", 99999, 33)
        }

        Div({ classes("form-group", "input-group-append"); style { height(div1Hei) } }) {
            ffInput1("Lote fabr.", _txnLote, "S", 20, 33)
            ffInput1("Validade", _txnValid, "D4", 10, 33, _onFocusIn = {}, _onFocusOut = {
                val dt1 = _txnValid.text().ffDsd()
                val dt2 = dt1.ffSoma(opro.EST_DIASVALID.times(-1))
                println0("@aqui ${_txnValid.text()} $dt1 $dt2 ${opro.EST_DIASVALID}")
                _txnFabric.text(dt2.ffDdBr(4))
            })
            ffInput1("Fabricação", _txnFabric, "D4", 10, 33, false)
        }

        Div({ classes("form-group", "input-group-append"); style { height(div1Hei) } }) {
            ffInputN("Saldo", _txnSaldo, "N", 10, 33)
            ffButtonDiv(
                "Adicionar lote",
                {
                    clicknAdicionarLote(_txnSaldo.text(), _txnLote.text(), _txnFabric.text(), _txnValid.text(), _txnQtdEmb.text()) { o ->
                        if (o) {
                            _tela.value = "barras"
                            _txnLote.text("")
                            _txnValid.text("")
                            _txnFabric.text("")
                            _txnSaldo.text("")
                            _txnQtdEmb.text("")
                        }
                    }
                }, 66
            )
        }
    }

//******************************************************************************* INICIO DOS EVENTOS

    fun clicknAdicionarLote(
        _txnSaldo: String, _txnLote: String, _txnFabric: String, _txnValid: String, _txnQtdEmb: String,
        callback: (Boolean) -> Unit
    ): Boolean {

        ff.println0("clicknAdicionaLote ${_txnFabric}")

        val _prolot = Produtolote()
        _prolot.PROLOT_SALDO = _txnSaldo.ffVsdo()
        _prolot.PROLOT_LOTEFAB = _txnLote
        _prolot.PROLOT_DTVAL = _txnValid.ffDsd()
        _prolot.PROLOT_DTFABR = _txnFabric.ffDsd()
        _prolot.PROLOT_QTDEMB = _txnQtdEmb.ffVsi()

        if (_prolot.PROLOT_SALDO == 0.0)
            ffMsgAviso("Informe o saldo do lote!")
        else if (_prolot.PROLOT_DTFABR.compare(_prolot.PROLOT_DTVAL) >= 0)
            ffMsgAviso("Data de fabricação maior que validade, ${_prolot.PROLOT_DTFABR}!")
        else if (_prolot.PROLOT_DTFABR.compare(Date()) > 0)
            ffMsgAviso("Data de fabricação maior que o dia de hoje")
        else if (_prolot.PROLOT_LOTEFAB.equals(""))
            ffMsgAviso("Informe o lote do fabricante")
        else {
            try {
                _prolot.PROLOT_EMPRESA = giEmpresa
                _prolot.PROLOT_PRODUTO = lpro!![0].ID_PRODUTO
                _prolot.PROLOT_USUARIO = ff.goFUNCIONARIO.FUNC_LOGON
                Service().postGen(_prolot.asDynamic(), "${ff.gsDom1}/produtolote/015/prolote") { obj ->
                    if (obj.PAD_CODIGO.compareTo(200) == 0) {
                        callback(true)
                        ffMsgAviso("Gravado")
                    } else {
                        callback(false)
                        ffMsgAviso("Falha ao incluir o registro!")
                    }
                }
            } catch (e: Exception) {
                ffMsgAviso("Erro ${e.message}")
            }

        }
        return (true)
    }

//    fun onkeyPress_codigo(_produto: String, _key: String, cb: (Boolean) -> Unit) {
//        if (_key.equals("Enter")) {
//            Produto().consultarProduto(_produto, false) { lista ->
//                lpro = lista
//                cb(true)
//                //bodyBarras()
//            }
//        }
//    }

    fun clickInput_codigo(): Boolean {
        println0("clickInput")
        return true
    }

    fun clickNovaConsulta(): Boolean {
        println0("clickNovo")
        show("")
        return true
    }

    fun clickGravar(
        _tela: MutableState<String>,
        _pro: Produto,
        _tipo: String,
        _ean: String,
        _qtdVenda: String,
        _reEan: Int,
        callback: (Boolean) -> Unit
    ): Boolean {
        println0("clickGravar")

        //var sResult = false
        try {
            var bContinua = true
            if ((_tipo.equals("C")) && (_reEan == 2)) { //(lbCxDUN!!.innerText.contains("Qtde"))) {
                bContinua = ffMsgWindow("Continuar com a correção da caixa de embarque ?")
            }

            if ((bContinua) && (_pro.PRO_EMPRESA > 0)) {
                if (_ean != "") {
                    val opro = Produto()
                    opro.PRO_EMPRESA = _pro.PRO_EMPRESA
                    opro.ID_PRODUTO = _pro.ID_PRODUTO
                    opro.ESTG_TIPO = _tipo
                    opro.ESTG_EAN = _ean
                    opro.ESTG_UNIDVENDA = _qtdVenda.ffVsdo()

                    //console.log("${_pro.PRO_EMPRESA}, ${_pro.ID_PRODUTO}, ${oProduto!!.ESTG_TIPO}, ${oProduto!!.ESTG_EAN}, ${oProduto!!.ESTG_UNIDVENDA}")
                    println0("zuza9999_")
                    println0(opro)

                    Service().postGen(
                        opro.asDynamic(),
                        "${ff.gsDom1}/produto/018/prodBarras/${ff.goFUNCIONARIO.ID_FUNCIONARIO}"
                    ) { obj ->
                        println0("zuza chegou aqui")
                        println0(obj)
                        if (obj.PAD_CODIGO.compareTo(200) == 0) {
                            //consultarProduto(opro.ID_PRODUTO.toString(),false)
                            //sResult = true
                            ffMsgAviso("Gravado")
                        } else {
                            ffMsgAviso("Erro!")
                            console.log("erro ${obj.PAD_CODIGO}")
                        }
                        callback(true)
                    }
                }
            } else {
                ffMsgAviso("Informe o produto!")
                clickNovaConsulta()
            }
        } catch (e: Exception) {
            ffMsgAviso("Erro!")
        }
        _tela.value = "barras$_tipo"
        return true
    }

    //********************************************************************************* INICIO DAS FUNCOES
    private fun atualizarProdutoLote(item: Produtolote, callback: (Boolean) -> Unit) {

        item.PROLOT_SALDO = item.PROLOT_SALDO + item.DIF_SALDO00
        console.log("atualizarProdutoLote ${item.PROLOT_SALDO} ${item.DIF_SALDO00}")
        Service().postGen(item.asDynamic(), "${ff.gsDom1}/produtolote/016/prolote") { obj ->
            if (obj.PAD_CODIGO.compareTo(200) == 0) {
                ffMsgAviso("Gravado")
                callback(true)
            } else {
                ffMsgAviso("Falha ao atualizar saldo do lote!")
                console.log("erro ${obj.PAD_CODIGO}")
                callback(false)
            }
        }
    }


}